import styled from 'styled-components'

export const MultiLine = styled.div`
  white-space: pre-wrap;
`
